module.exports = __webpack_public_path__ + "img/0855-notification-circle.764fe295.svg";